import gsap from 'gsap'
import barba from '@barba/core'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Preloader } from './preloader'

import { initAnimationBanner } from './animationBanner'
import { introduction } from './introduction'

import { initLenis, lenis, scrollToStart, scrollTo } from './lenis'
import { initAlpine } from './alpine'
import { splitType } from './splitType'
import { Navigation } from './navigation'
import { services } from './services'
import { swiperGallery } from './swiperGallery'
import { swiperGrid } from './swiperGridCarousel'
import { initHighlightText } from './utilities'
import { googleMaps } from './map'
import { footer } from './footer'
import { bannerAbout } from './bannerAbout'
import { balanceText } from './balanceText'
import { afterTransition } from './afterTransition'
import { initCaseStudyBanner } from './caseStudyBanner'
import { initServicesBanner } from './servicesBanner'
import { parallaxImages } from './parallaxImages'
import { parallaxSection } from './parallaxSection'
import { marquees } from './marquee'
import { beliefs } from './beliefs'
import { lazyVideo } from './lazyVideo'
import { principles } from './principles'
import { runAnimations } from './inview'
import { headerMixBlend } from './headerMixBlend'
import lottie, { lottieAnimations } from './lottie'
import { resetCursorClasses } from './cursor'
import { initForms } from './formie'

// TODO: Check through this file, tidy up and remove unwanted scripts.

const initBarba = () => {
  const header = document.querySelector('.header')
  const cloak = document.querySelector('.cloak')
  const navigation = new Navigation(document.querySelector('.navigation'))
  const preloader = new Preloader()

  barba.init({
    debug: false,
    timeout: 5000,
    schema: {
      prefix: 'data-load'
    },
    prevent: ({ el }) => el.classList.contains('ab-item'),
    transitions: [
      {
        name: 'basic-transition',
        sync: true,
        once(data) {},
        leave(data) {
          const done = this.async()

          header.dataset.theme = data.next.container.dataset.header
          cloak.style.backgroundColor = data.next.container.dataset.background

          gsap.to(cloak, {
            duration: 0.3,
            opacity: 1,
            onComplete: () => {
              done()
              navigation.snapCloseNavigation()
            }
          })
        },
        beforeEnter(data) {},
        after(data) {
          const done = this.async()

          cloak.style.pointerEvents = 'none'

          gsap.to(cloak, {
            duration: 0.2,
            opacity: 0,
            onComplete: done
          })
        }
      }
    ]
  })

  barba.hooks.once((data) => {
    header.dataset.theme = data.next.container.dataset.header

    // loader()
    initLenis()
    initAlpine()
    splitType()
    initHighlightText()
    initAnimationBanner()
    initServicesBanner()
    introduction()
    swiperGrid()
    swiperGallery()
    googleMaps()
    footer()
    scrollTo()
    bannerAbout()
    balanceText()
    initCaseStudyBanner()
    marquees()
    parallaxImages()
    parallaxSection()
    beliefs()
    services()
    principles()
    runAnimations()
    headerMixBlend()
    lottieAnimations()
    lazyVideo()
  })

  barba.hooks.leave((data) => {})

  barba.hooks.afterLeave((data) => {
    scrollToStart()
    ScrollTrigger.killAll()
  })

  barba.hooks.enter((data) => {
    navigation.setActiveState()
    htmx.process(data.next.container)
  })

  barba.hooks.after((data) => {
    splitType()
    initHighlightText()
    afterTransition()
    initAnimationBanner()
    initServicesBanner()
    introduction()
    swiperGrid()
    swiperGallery()
    googleMaps()
    footer()
    scrollTo()
    initCaseStudyBanner()
    marquees()
    bannerAbout()
    balanceText()
    parallaxImages()
    parallaxSection()
    beliefs()
    services()
    principles()
    runAnimations()
    headerMixBlend()
    lottieAnimations()
    resetCursorClasses()
    lazyVideo()
    initForms()

    let scripts = document.querySelectorAll('main script')
    scripts.forEach((script) => eval(script.innerHTML))
  })
}

export default initBarba
